import isEnabled from '../../services/is-experiment-enabled';
export var getExperiments = function (state) { var _a; return (_a = state.experiments) !== null && _a !== void 0 ? _a : {}; };
export var isExperimentEnabled = function (state, name, value) {
    return isEnabled(getExperiments(state), name, value);
};
